/**
 * Visual Effects System — Core Types
 *
 * Defines spell area effects, damage type visuals, and shape definitions
 * for persistent map effects. Part of EPIC-0017.
 */
/** Color palette per effect name */
export const EFFECT_COLORS = {
    fire: { primary: 0xff6600, secondary: 0xff3300, glow: 0xff4400 },
    ice: { primary: 0x66ccff, secondary: 0x99ddff, glow: 0x44aaff },
    eldritch: { primary: 0x44ff44, secondary: 0x22cc22, glow: 0x33ff33 },
    divine: { primary: 0xffd700, secondary: 0xfff4c2, glow: 0xffe066 },
    psychic: { primary: 0xcc66ff, secondary: 0x9933cc, glow: 0xbb55ee },
    decay: { primary: 0x66cc33, secondary: 0x446622, glow: 0x55aa22 },
    thunder: { primary: 0xccccff, secondary: 0x8888ff, glow: 0xaaaaff },
    menace: { primary: 0xcc0000, secondary: 0x880000, glow: 0xaa0000 },
    fey: { primary: 0xff88cc, secondary: 0xcc66ff, glow: 0xee77bb },
    darkness: { primary: 0x111111, secondary: 0x080808, glow: 0x0a0a0a },
};
export const EFFECT_BEHAVIORS = {
    fire: { motion: 'up', lifetime: [0.8, 1.6], density: 1.4, particleShape: 'teardrop', rotates: true, glow: 'bright' },
    ice: { motion: 'drift', lifetime: [2.0, 4.0], density: 1.0, particleShape: 'crystal', rotates: true, glow: 'soft' },
    thunder: { motion: 'zap', lifetime: [0.3, 0.7], density: 0.8, particleShape: 'bolt', rotates: false, glow: 'flicker' },
    divine: { motion: 'radial', lifetime: [1.2, 2.2], density: 1.1, particleShape: 'star', rotates: true, glow: 'bright' },
    decay: { motion: 'down', lifetime: [1.5, 3.0], density: 1.0, particleShape: 'blob', rotates: false, glow: 'none' },
    eldritch: { motion: 'orbit', lifetime: [1.0, 2.2], density: 1.2, particleShape: 'tendril', rotates: true, glow: 'soft' },
    psychic: { motion: 'orbit', lifetime: [0.8, 1.6], density: 1.0, particleShape: 'arc', rotates: true, glow: 'soft' },
    menace: { motion: 'up', lifetime: [1.5, 3.0], density: 1.1, particleShape: 'wisp', rotates: false, glow: 'none' },
    fey: { motion: 'erratic', lifetime: [0.6, 1.4], density: 1.3, particleShape: 'sparkle', rotates: true, glow: 'bright' },
    darkness: { motion: 'drift', lifetime: [3.0, 5.0], density: 0.4, particleShape: 'mote', rotates: false, glow: 'none' },
};
/** Map 5e damage types to effect names */
export function damageTypeToEffect(damageType) {
    const map = {
        fire: 'fire',
        cold: 'ice',
        lightning: 'thunder',
        thunder: 'thunder',
        acid: 'decay',
        poison: 'decay',
        necrotic: 'menace',
        radiant: 'divine',
        force: 'psychic',
        psychic: 'psychic',
    };
    return map[damageType.toLowerCase()] || 'divine';
}
//# sourceMappingURL=effect-types.js.map